import React, { useRef, useState } from "react";
import "components/common/datatable/datatable.css";
import { InputText } from "primereact/inputtext";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";

import * as N from "components/common/datatable/dataTableElements";

import { useAppSelector } from "store/store";
import { AnyObject } from "chart.js/types/basic";

const NftTable = ({ data }: { data: any }) => {
  const dt = useRef<any>(null);
  const [globalFilter, setGlobalFilter] = useState(null);

  const header = (
    <div className="table-header">
      <h5 className="p-mx-0 p-my-1">Nft Transactions</h5>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e: any) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span>
    </div>
  );

  return (
    <>
      <N.MainDiv className="datatable-crud-demo">
        <N.MainCard className="card">
          <N.DataTables
            ref={dt}
            value={data ? data : []}
            dataKey="id"
            paginator
            globalFilter={globalFilter}
            rows={10}
            rowsPerPageOptions={[5, 10, 25]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Users"
            header={header}
            responsiveLayout="scroll"
          >
            <N.Columns
              field="nft_id"
              header="Nft Id"
              sortable
              style={{ minWidth: "12rem" }}
            ></N.Columns>
            <N.Columns
              field="transaction_hash"
              header="Description"
              sortable
              style={{ minWidth: "16rem" }}
            ></N.Columns>
            <N.Columns
              field="token_id"
              header="Token Id"
              sortable
              style={{ minWidth: "10rem" }}
            ></N.Columns>
          </N.DataTables>
        </N.MainCard>
      </N.MainDiv>
    </>
  );
};

export default NftTable;
